module.exports = __webpack_public_path__ + "img/c04_unitvillagers_Normal_ua.e7072c6f.webp";